/* MAXLER homepage hero: horizontal slide using the existing Flickity carousel.
 * Loaded after the vendor library, before the theme slideshow is initialized.
 */
(function () {
  'use strict';
  var Flickity = window.Flickity;
  if (!Flickity || !Flickity.prototype ||
      typeof Flickity.prototype._create !== 'function') return;

  var originalCreate = Flickity.prototype._create;
  if (originalCreate.maxlerHorizontalHero) return;

  function createWithHorizontalHero() {
    var element = this.element;
    var section = element && element.closest &&
      element.closest('[data-section-type="video-slideshow-section"]');
    var sectionId = section && section.getAttribute('data-section-id');
    // Shopify prefixes template section IDs with template--...__.
    var isHomeHero = sectionId &&
      /(?:^|__)slideshow_with_video_kUrrQT$/.test(sectionId) &&
      element.matches && element.matches('.hero[data-slide-count]');

    if (isHomeHero) {
      var reducedMotion = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) {
        this.options.autoPlay = false;
      } else {
        this.options.fade = false;
        // Mobile transitions should settle faster; leave desktop unchanged.
        var mobile = window.matchMedia &&
          window.matchMedia('(max-width: 768px)').matches;
        this.options.selectedAttraction = mobile ? 0.042 : 0.018;
        this.options.friction = mobile ? 0.30 : 0.25;
        element.classList.add('maxler-horizontal-hero');
      }
    }
    return originalCreate.apply(this, arguments);
  }

  createWithHorizontalHero.maxlerHorizontalHero = true;
  Flickity.prototype._create = createWithHorizontalHero;

  // Start fetching neighbouring slides once the initial hero has finished loading.
  // This avoids decoding a large mobile image for the first time mid-transition.
  function warmMobileSlides() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 768px)').matches) return;
    var section = document.querySelector('[data-section-id$="slideshow_with_video_kUrrQT"]');
    if (!section) return;
    var slides = section.querySelectorAll('.slideshow__slide:not(.is-selected) picture img');
    Array.prototype.forEach.call(slides, function (img) {
      img.loading = 'eager';
      img.decoding = 'async';
    });
  }
  function scheduleSlideWarmup() {
    window.setTimeout(warmMobileSlides, 400);
  }
  if (document.readyState === 'complete') {
    scheduleSlideWarmup();
  } else {
    window.addEventListener('load', scheduleSlideWarmup, { once: true });
  }
})();
